import { render, staticRenderFns } from "./sales-import.vue?vue&type=template&id=1501ab36&scoped=true"
import script from "./sales-import.vue?vue&type=script&lang=js"
export * from "./sales-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501ab36",
  null
  
)

export default component.exports